module.exports = __webpack_public_path__ + "static/media/IMG-20220519-WA0013.1502affb.jpg";